<div id="wa-legend-card-container">
    <div id="wa-legend-line" [ngStyle]="{'border-top': '4px ' + legendItem.borderStyle + ' ' + legendItem.color}"></div>
    <div>{{legendItem.sourceName | translate}}</div>
</div>
